<template>
    <div class="toasts-wrapper" v-if="toasts.length ">
      <Toast
        v-for="(toast, index) of toasts"
        :key="index" :toast="toast" >
      </Toast>
    </div>
  </template>

<script>
import Toast from '@/components/toast/Toast.vue'
export default {
  name: 'Toasts',
  components: { Toast },
  computed: {
    toasts () {
      return this.$store.state.toasts
    }
  }
}
</script>

  <style scoped>
  .toasts-wrapper {
  width: 350px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  right: 2rem;
  bottom: 1rem;
  z-index: 1000;
}
  </style>



// WEBPACK FOOTER //
// src/components/toast/Toasts.vue